import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './style/App.css';

const API_BASE = '/api';
const TENANT_KEY_PATTERN = /^[a-z][a-z0-9_]{0,63}$/;

const App: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const tenant = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tenant')?.trim() || '';
  }, [location.search]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');
    if (!TENANT_KEY_PATTERN.test(tenant)) {
      setMessage('Link di registrazione non valido: tenant mancante o non valido.');
      return;
    }
    if (!username.trim() || !email.trim() || !password) {
      setMessage('Compila tutti i campi.');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE}/register?tenant=${encodeURIComponent(tenant)}`,
        { username: username.trim(), email: email.trim(), password, tenant_key: tenant },
        { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
      );
      // Effettua il login usando lo stesso contratto di Login.tsx.
      // Il cookie di sessione viene salvato dal browser grazie a withCredentials.
      try {
        await axios.post(
          `${API_BASE}/login`,
          { username: username.trim(), password, tenant_key: tenant },
          {
            headers: { 'Content-Type': 'application/json', 'X-Tenant-Key': tenant },
            withCredentials: true,
          }
        );
        setPassword('');
        navigate(`/home?tenant=${encodeURIComponent(tenant)}`, { replace: true });
      } catch {
        setPassword('');
        setMessage('Account creato, ma accesso automatico non riuscito. Accedi dalla pagina di login.');
      }
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        const serverMessage = error.response?.data?.error;
        setMessage(typeof serverMessage === 'string' ? serverMessage : 'Errore durante la registrazione.');
      } else {
        setMessage('Errore durante la registrazione.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="registerPage">
      <div className="registerContainer">
        <h1>Register</h1>
        <form onSubmit={handleSubmit}>
          <label htmlFor="registration-username">Username</label>
          <input id="registration-username" value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" required />
          <label htmlFor="registration-email">Email</label>
          <input id="registration-email" type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required />
          <label htmlFor="registration-password">Password</label>
          <input id="registration-password" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required />
          <button type="submit" disabled={submitting || !TENANT_KEY_PATTERN.test(tenant)}>
            {submitting ? 'Registrazione in corso...' : 'Register'}
          </button>
        </form>
        <div className="loginRedirect">
          <span>Already have an account?</span>
          <button type="button" className="loginLinkButton" onClick={() => navigate(`/login${tenant ? `?tenant=${encodeURIComponent(tenant)}` : ''}`)}>
            Go to login
          </button>
        </div>
        {(!TENANT_KEY_PATTERN.test(tenant) || message) && <p role="alert">{message || 'Tenant mancante nell’URL di registrazione.'}</p>}
      </div>
    </div>
  );
};

export default App;
